import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { DynamicContentService } from 'src/app/shared/services/dynamic-content/dynamic-content.service';
import { ResizeService } from 'src/app/shared/services/resize/resize.service';
import { SopoLoadingService } from 'src/app/shared/services/sopo-loading/sopo-loading.service';

@Component({
    selector: 'app-certificate-preview',
    templateUrl: './certificate-preview.component.html',
    styleUrls: ['./certificate-preview.component.scss'],
    standalone: false
})

export class CertificatePreviewComponent implements OnInit, OnDestroy {

    filePath: string ;
    openCer: boolean = false;
    rendered: boolean = false;
    alertPresent: boolean = false;
    zoomRange: number = 1.1;
    containerStyle = {};

    private _resizeSubscription: Subscription;

    constructor(
        public loadingCtrl: SopoLoadingService,
        public dynamicContentService: DynamicContentService,
        private resizeService: ResizeService,
        private ref: ChangeDetectorRef,
    ) { }

    ngOnInit() {
        this._resizeSubscription = this.resizeService.getCertificateFontSize().subscribe((fontSize: string) => {
            this.containerStyle = { 'font-size': fontSize };
            this.ref.detectChanges();
        });
        this.filePath = '/assets/docs/RNG-Social-Poker-Odysseus-Software-2018-September-15.pdf';
        this.showCertificate();
    }

    showCertificate() {
        if (!this.openCer) {
            this.alertControl('present');
        }
        this.openCer = true;
    }

    renderedPDF() {
        if (!this.rendered) this.zoomOut();
        this.rendered = true;
        this.alertControl('dismiss');
    }

    dismiss() {
        this.dynamicContentService.closeCertificatePreview();
        this.openCer = false;
        this.rendered = false;
    }

    zoomIn() {
        this.zoomRange += 0.1;
    }

    zoomOut() {
        this.zoomRange -= 0.1;
    }

    async alertControl(control: string) {
        if (control === 'present' && !this.alertPresent) {
            await this.loadingCtrl.present('general');
            this.alertPresent = true;
        } else if (control === 'dismiss') {
            this.loadingCtrl.dismiss('general');
            this.alertPresent = false;
        }
    }

    ngOnDestroy() {
        this._resizeSubscription?.unsubscribe();
    }

}
